import { client as r } from "./webchat-client4.js";
const t = (e) => (e.client ?? r).delete({
  url: "/conversations/{id}",
  ...e
}), c = (e) => (e.client ?? r).get({
  url: "/conversations/{id}",
  ...e
}), l = (e) => (e.client ?? r).get({
  url: "/conversations",
  ...e
}), n = (e) => (e.client ?? r).post({
  url: "/conversations",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), s = (e) => (e.client ?? r).get({
  url: "/conversations/{id}/messages",
  ...e
}), u = (e) => (e.client ?? r).get({
  url: "/conversations/{id}/participants",
  ...e
}), d = (e) => (e.client ?? r).post({
  url: "/conversations/{id}/participants",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), g = (e) => (e.client ?? r).delete({
  url: "/conversations/{id}/participants/{userId}",
  ...e
}), h = (e) => (e.client ?? r).get({
  url: "/conversations/{id}/participants/{userId}",
  ...e
}), v = (e) => (e.client ?? r).delete({
  url: "/messages/{id}",
  ...e
}), C = (e) => (e.client ?? r).get({
  url: "/messages/{id}",
  ...e
}), m = (e) => (e.client ?? r).put({
  url: "/messages/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), y = (e) => (e.client ?? r).post({
  url: "/messages",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), j = (e) => (e.client ?? r).delete({
  url: "/messages/{id}/feedback",
  ...e
}), T = (e) => (e.client ?? r).put({
  url: "/messages/{id}/feedback",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), M = (e) => (e.client ?? r).delete({
  url: "/users/me",
  ...e
}), i = (e) => (e.client ?? r).get({
  url: "/users/me",
  ...e
}), f = (e) => (e.client ?? r).put({
  url: "/users/me",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), k = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  url: "/users",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), P = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  url: "/users/key",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), U = (e) => (e.client ?? r).get({
  url: "/events/{id}",
  ...e
}), b = (e) => (e.client ?? r).post({
  url: "/events",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), F = (e) => (e.client ?? r).post({
  url: "/files",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), E = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  url: "/p",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
});
export {
  T as addMessageFeedback,
  d as addParticipant,
  n as createConversation,
  b as createEvent,
  F as createFile,
  y as createMessage,
  k as createUser,
  t as deleteConversation,
  v as deleteMessage,
  M as deleteUser,
  P as generateUserKey,
  c as getConversation,
  U as getEvent,
  C as getMessage,
  h as getParticipant,
  i as getUser,
  s as listConversationMessages,
  l as listConversations,
  u as listParticipants,
  j as removeMessageFeedback,
  g as removeParticipant,
  E as sendPerfMetrics,
  m as updateMessage,
  f as updateUser
};
